export function isContentTypeImage(contentType?: string): boolean {
  return [`image/jpeg`, `image/png`, `image/gif`].some((s) => s === contentType)
}
